export enum TABLE_MODE {
  CLIENT = 'client',
  SERVER = 'server',
}
